export default __webpack_public_path__ + "static/media/imageModal.407442cb.png";